// Skip cart sections that this theme does not actually render.
//
// cart.js hardcodes four sections in getSectionsToRender(), one of which is
// #cart-icon-bubble from Dawn's stock sections/header.liquid. This store renders
// the custom sections/vox-header.liquid instead, which has its own cart link and
// no #cart-icon-bubble. The re-render loop does:
//
//   document.getElementById(section.id).querySelector(section.selector)
//
// with no null guard, so it throws a TypeError on the second entry. That rejects
// the whole promise: #main-cart-items (first) has already been replaced, but
// #main-cart-footer (last) never is, leaving the line item showing the new
// quantity while the footer keeps the old total, plus a spurious
// "There was an error while updating your cart." The cart change itself did
// succeed server-side; only the client-side repaint broke.
['cart-items', 'cart-drawer-items'].forEach((tag) => {
  customElements.whenDefined(tag).then((ctor) => {
    const original = ctor.prototype.getSectionsToRender;
    if (typeof original !== 'function') return;

    ctor.prototype.getSectionsToRender = function () {
      return original.call(this).filter((section) => document.getElementById(section.id));
    };
  });
});
